import React, { Component } from "react";
import WithConsumer from '../../context/WithConsumer';

const Cover = ({ context }) => {
	
	const ctxSiteStartLoaded 	= () => context.siteStartLoaded;
	const siteStartLoaded 		= ctxSiteStartLoaded();
	
	const ctxSiteEndLoaded 		= () => context.siteEndLoaded;
	const siteEndLoaded 		= ctxSiteEndLoaded();
	
	let coverClass = 'c-cover';
	if (siteStartLoaded) {
		coverClass = coverClass + ' state-start-loader';
	}
	if (siteEndLoaded) {
		coverClass = coverClass + ' state-end-loader';
	}
	
	return (
		<div className={coverClass}></div>
	)
	
}
export default WithConsumer(Cover);